<div class="max-w-container w-full px-4 md:px-14">
  <slot />
</div>
